import type { ReactElement } from 'react';
import { Link } from 'react-router';

/**
 * 제출 뒤 화면.
 *
 * 「보내드렸어요」라고 쓰지만 발송 성공을 확인한 문장은 아니다 — 서버는 메일이 실패해도 제출을
 * 성공으로 돌려준다(응답은 이미 저장됐다). 그래서 스팸함 안내를 함께 둔다. 못 받은 사람은
 * 같은 주소로 다시 내면 서버가 그때 다시 보낸다.
 */
export function SurveySent({ wantsConsulting }: { wantsConsulting: boolean }): ReactElement {
  return (
    <div className="u-container flex max-w-[34rem] flex-col items-center gap-5 py-24 text-center">
      <span aria-hidden="true" className="text-[2rem]">
        ✓
      </span>
      <h1 className="text-[1.375rem] font-bold tracking-[-0.04em]">
        설문에 참여해 주셔서 감사합니다
      </h1>
      <p className="text-[14px] leading-[1.8] text-muted-foreground">
        입력하신 메일로 AI 워크플로우 + GPT 지침 프롬프트 자료를 보내드렸어요.
        <br />
        메일이 보이지 않으면 스팸함도 확인해 주세요.
      </p>
      {wantsConsulting ? (
        <p className="text-[14px] leading-[1.8] text-muted-foreground">
          1:1 컨설팅 추첨은 당첨되시면 메일로 따로 안내드리겠습니다.
        </p>
      ) : null}
      <Link
        to="/library"
        className="inline-flex h-11 items-center rounded-md border border-foreground px-5 text-sm font-medium"
      >
        자료실로 돌아가기
      </Link>
    </div>
  );
}
